import { render, staticRenderFns } from "./newGroupForm.vue?vue&type=template&id=6410ce2d"
import script from "./newGroupForm.vue?vue&type=script&lang=js"
export * from "./newGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports